export const defaultTitle = "Menina Dourada | Moda Praia Feminina";
export const defaultDescription =
  "Descubra cangas, moda praia feminina e peças com estilo tropical na Menina Dourada.";
export const defaultImage = "https://meninadourada.shop/android-chrome-512x512.png";
export const defaultUrl = "https://meninadourada.shop";
export const defaultKeywords =
  "moda praia feminina, canga de praia, canga estampada, saída de praia, beachwear, menina dourada";
